<template>
  <div class="home">
    <HeaderComp />
    <HeroComp />
    <PlanoComp />
    <ServicoComp />
    <!--<IntegracaoComp />
    <RecursoComp />-->
    <FaqComp />
    <SobreNosComp />
    <FooterComp />
</div>
</template>

<script>
import HeaderComp from '@/components/Header.vue'
import HeroComp from '@/components/Hero.vue'
import ServicoComp from '@/components/ServicoComp.vue'
// import IntegracaoComp from '@/components/IntegracaoComp.vue'
// import RecursoComp from '@/components/RecursoComp.vue'
import PlanoComp from '@/components/PlanoComp.vue'
import FaqComp from '@/components/FaqComp.vue'
import SobreNosComp from '@/components/SobreNosComp.vue'
import FooterComp from '@/components/Footer.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderComp,
    HeroComp,
    ServicoComp,
    // IntegracaoComp,
    // RecursoComp,
    PlanoComp,
    FaqComp,
    SobreNosComp,
    FooterComp
  }
}

</script>
